import config from "../../src/common/default_config";

export default class options extends config {
  // General options --------------------
  static forgotPasswordLink =
    "https://compte.centrefrance.com/oubli_motdepasse";
  static cookieEnabled = false;
  static helpUrl = "https://static.centrefrance.com/pages/cfjournal/faq.html";
  static subscriptionOptions = {
    subscriptionType: "subscription",
    subscriptionProvider: "CFR",
  };
  static editor = "Centre France";
  static contactEditor = "http://www.centrefrance.com/";
  static SSOCookieName = "cfToken";
  static SSOEnabled = true;
  static homeRedirectionLink = "//portail.centrefrance.com";
  static dateFormat = "D MMMM YYYY";
  static SSOCookieOptions = { path: "", domain: "/centrefrance.com" };
  static useCookiePostfix = true;

  // Kiosk options --------------------
  static displayHorsSerieArchive = false;
  static usePromoSpot = false;
  static channel = 1;
  static displayKiosqueIframeBanner = false;
  static paywallIframeBannerSource =
    "https://static.centrefrance.com/pages/cfjournal/aboBannerW.html";
  static disclaimerurl =
    "https://static.centrefrance.com/pages/cfjournal/cgu.html";
  static spaceBetweenSlidesSideMenu = { phone: 19, tablet: 19 };
  static homeRelativeDepth = -1;
  static logo404 = "logo404.png";

  // Reader options --------------------
  static page_width_reference = 100000;
  static page_height_reference = 100000;
  static page_ratio = 1.4925373134;
  static usePdfDesktop = true;
  static usePdfPhoneNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfPhone = true;
  static usePdfTabletNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfTablet = true;
  static printCroppedPdf = true;

  static albSlideOnlyOnePage = true;
  static replicaReadingModeToggle = {
    phone: false,
    tablet: true,
    desktop: true,
  };
  static replicaReadingModeDefault = {
    phone: false,
    tablet: false,
    desktop: true,
  };
  static defaultPreferredViewer = "replica";
}



// WEBPACK FOOTER //
// ./clients/cfr-mt/config.js